import { FC } from 'react'
import {
  BubblePosition,
  BubbleWrapper,
  Container,
  Image,
  ImageContainer,
} from './styled'

type Props = React.ImgHTMLAttributes<HTMLImageElement> & BubblePosition

export const Bubble: FC<Props> = ({ $position, ...props }) => (
  <Container $position={$position} $isHidden={!props.src}>
    <BubbleWrapper>
      <ImageContainer>
        <Image {...props} />
      </ImageContainer>
    </BubbleWrapper>
  </Container>
)
